import { toPlainText } from '@portabletext/react';
import { IFilmomtale } from 'src/lib/types/Filmomtale';
import IPremiumLandingPage from "src/lib/types/IPremiumLandingPage";
import Head from 'next/head';
import { useRouter } from 'next/router';

//#region [Props]
type FilmSeoProps = {
	document: IPremiumLandingPage
};
//#endregion

//#region [Component]
export default function PremiumLandingPageSeo({ document }: FilmSeoProps) {
	const router = useRouter();

	const movie = document.movie as IFilmomtale;

	const metaTitle = `${movie.title}${movie?.year ? ` - ${movie?.year }` : ""} - Filmweb`;

	let metaDescription = movie?.oneliner?.trim();
	if (!metaDescription && movie?.ingress) {
		metaDescription = toPlainText(movie.ingress);
	}

	const url = router.asPath.split("?", 1)[0];


	return <Head>
		<meta key="ogTitle" property="og:title" content={metaTitle} />

		{metaDescription && <>
			<meta key="ogDescrtiption" property="og:description" content={metaDescription} />
			<meta key="metaDescription" name="description" content={metaDescription} />
		</>}
		<meta key="ogUrl" property="og:url" content={`https://www.filmweb.no${url}`} />

		{/*imageUrl && <meta key="ogImage" property='og:image' content={imageUrl} />*/}

		<meta key="ogType" property="og:type" content="article" />
		<title key="title">{metaTitle}</title>
        <link key="canonical" rel="canonical" href={`https://www.filmweb.no/film/${document.movie.mainVersionEDI}`} />

	</Head>;
}
//#endregion
